<style lang="scss" src='./LocalWeatherDetails.scss' scoped></style>
<template src="./LocalWeatherDetails.html"></template>

<script>

import LocalWeatherData from '@/views/localWeather/data/LocalWeatherData.vue';

import { cleanUpStation } from '@/api/index';

export default {
  name: 'LocalWeatherDetails',
  components: {
      LocalWeatherData,
  },
  props: {
  },
  data() {
    return ({
    });
  },
  computed: {},

  methods: {
    openModal() {
      this.$refs['modal-local-weather-data'].show();
      
    },
  },

  beforeCreate() {},

  created() {},

  mounted() {},
};
</script>
